import { StyleSheet } from 'react-native';
import type { AccessibilityProps, ViewProps } from 'react-native';

import SanityBlockRenderer from 'components/sanity-block-renderer';
import { Typography } from 'components/ui';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { BadgeProgressBar } from 'pages/loyalty/loyalty-badges/badge-progress-bar';
import { LoyaltyBadgeImage } from 'pages/loyalty/loyalty-badges/loyalty-badge-image';
import { ILoyaltyBadge } from 'pages/loyalty/loyalty-badges/types';
import { primitive } from 'styles/constants';

import { BadgeBaseCard } from './badge-base-card';

export { BADGE_CARD_WIDTH, BADGE_CARD_MIN_HEIGHT } from './badge-base-card';

export const BadgeCard = ({
  badge,
  onPress,
  accessibilityRole,
  style,
}: {
  badge: ILoyaltyBadge;
  style?: ViewProps['style'];
  onPress?: () => void;
  accessibilityRole: AccessibilityProps['accessibilityRole'];
}) => {
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  return (
    <BadgeBaseCard
      style={style}
      image={<LoyaltyBadgeImage badge={badge} style={styles.badgeImage} />}
      title={
        <Typography
          variant="headerThree"
          lineHeight={isDesktopLarge ? 22 : undefined}
          style={styles.title}
          accessibilityLevel={3}
        >
          {badge.name}
        </Typography>
      }
      subtitle={
        <SanityBlockRenderer
          content={badge.shortDescription}
          textProps={{ style: styles.subtitle }}
        />
      }
      progress={
        !badge.earnedAt && badge.progress && badge.progress.currentValue > 0 ? (
          <BadgeProgressBar progress={badge.progress} />
        ) : undefined
      }
      onPress={onPress}
      accessibilityLabel={badge.name}
      accessibilityRole={accessibilityRole}
    />
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: primitive.fontSizes.sm,
    marginBottom: 0,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: primitive.fontSizes.xs,
    textAlign: 'center',
    color: primitive.$blackOpacity70,
  },
  badgeImage: {
    width: 104,
    height: 104,
  },
});
